module.exports = __webpack_public_path__ + "static/media/6423.8836b877.jpg";